/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupstatusconfirmed2Inputs */

const en_signupstatusconfirmed2 = /** @type {(inputs: Signupstatusconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed up`)
};

const de_signupstatusconfirmed2 = /** @type {(inputs: Signupstatusconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angemeldet`)
};

/**
* | output |
* | --- |
* | "Signed up" |
*
* @param {Signupstatusconfirmed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupstatusconfirmed2 = /** @type {((inputs?: Signupstatusconfirmed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupstatusconfirmed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupstatusconfirmed2(inputs)
	return de_signupstatusconfirmed2(inputs)
});
export { signupstatusconfirmed2 as "signupStatusConfirmed" }